import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { AnswerType, GPTEvalStatus, QuestionCollectionCategoryEnum } from '@app/shared/common/enums';
import { AnswerContentHRScoreResponse } from '@app/vinter/models/answer-content-form-item';
import { CodingAnswerItem } from '@app/vinter/models/answer/coding-answer-item';
import { ForeignLanguageOpenEndedAnswerItem } from '@app/vinter/models/answer/foreign-language-open-ended-asnwer-item';
import { ForeignLanguageVideoAnswerItem } from '@app/vinter/models/answer/foreign-language-video-answer-item';
import { MultipleChoiceAnswerItem } from '@app/vinter/models/answer/multiple-choice-answer-item';
import { OpenEndedAnswerItem } from '@app/vinter/models/answer/open-ended-answer-item';
import { PronunciationVideoAnswerItem } from '@app/vinter/models/answer/pronunciation-video-answer-item';
import { VideoAnswerItem } from '@app/vinter/models/answer/video-answer-item';
import { ApplicantRecordLogItem } from '@app/vinter/models/applicant-record-item';
import { ApplicantRecordService } from '@app/vinter/services/ApplicantRecord.service';
import { AnswerContentHRScoreService } from '@app/vinter/services/answer-content-hr-score.service';
import { AnswerService } from '@app/vinter/services/answer.service';
import { QuestionService } from '@app/vinter/services/question.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-answer-detail-sidebar',
  templateUrl: './answer-detail-sidebar.component.html',
  styleUrls: ['./answer-detail-sidebar.component.scss']
})
export class AnswerDetailSidebarComponent implements OnInit,OnChanges {

  @Input() selectedQuestion: any;
  @Input() sidebarVisible: boolean;
  @Input() questionCollectionCategoryId: string;
  @Input() applicationStepId: string;
  @Output() onHideAnswerSidebar: EventEmitter<any> = new EventEmitter<any>();
  @Output() getPreviousOrNextQuestion: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateSuspicionOfCheatingData: EventEmitter<ApplicantRecordLogItem> = new EventEmitter<ApplicantRecordLogItem>();

  changeScoreSidebarVisible: boolean = false;
  isScoreChanged: boolean = false;
  codingAnswer: CodingAnswerItem = null;
  changeVinterScoreSidebarVisible: boolean = false;
  multipleChoiceAnswer: MultipleChoiceAnswerItem = null;
  hrScoreDetails:  AnswerContentHRScoreResponse[];
  openEndedAnswer: OpenEndedAnswerItem = null;
  fullValue: number;
  valueToAdded: number;
  fractionValue: number = 0;
  videoAnswer: VideoAnswerItem = null;
  speakingAnswer: ForeignLanguageVideoAnswerItem = null;
  pronunciationVideoAnswer: PronunciationVideoAnswerItem = null;
  writingAnswer: ForeignLanguageOpenEndedAnswerItem = null;
  isResponse : boolean = false;
  answerType: number;
  vinterScore: any;
  scoreChange: number = 0;
  answerContentID: string;
  applicantID: string;
  isWaitingForAI = false;
  constructor(private answerService: AnswerService, 
    private applicantRecordService : ApplicantRecordService,
    private answerContentHRScoreService : AnswerContentHRScoreService

  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if((this.selectedQuestion ?? false)){
      if(this.selectedQuestion?.answerId){
        this.getAnswerData();
      }
     else{
      this.codingAnswer = null;
      this.multipleChoiceAnswer = null;
      this.openEndedAnswer = null;
      this.videoAnswer = null;
      this.speakingAnswer = null;
      this.pronunciationVideoAnswer = null;
      this.writingAnswer = null;
      this.vinterScore = 0;
      this.isResponse = true;
     }
    }
  }

  ngOnInit(): void {
    if((this.selectedQuestion ?? false)){
      if(this.selectedQuestion?.answerId){
        this.getAnswerData();
      }
      else{
        this.codingAnswer = null;
        this.multipleChoiceAnswer = null;
        this.openEndedAnswer = null;
        this.videoAnswer = null;
        this.speakingAnswer = null;
        this.pronunciationVideoAnswer = null;
        this.writingAnswer = null;
        this.vinterScore = 0;
        this.isResponse = true;
       }
    }
  }
  getChangedScoreData(answerContentID, applicantID){
    const filter = { answerContentID: answerContentID, applicantID: applicantID };
    this.answerContentHRScoreService.getChangedScoreData(filter).subscribe((response: AnswerContentHRScoreResponse[]) => {
      this.hrScoreDetails = response;
      this.fullValue = Math.floor(this.vinterScore);
      this.fractionValue = this.vinterScore - this.fullValue;
      this.valueToAdded = 1 - this.fractionValue;
      if (this.hrScoreDetails && this.hrScoreDetails.length > 0) {
        let effectiveScore: number;
        if((this.vinterScore < this.vinterScore + this.hrScoreDetails[0].scoreChange) && this.fractionValue != 0){
          effectiveScore = this.vinterScore + this.hrScoreDetails[0].scoreChange + this.valueToAdded;
        }
        else{
          effectiveScore = this.vinterScore + this.hrScoreDetails[0].scoreChange - this.fractionValue;
        }
        effectiveScore = Math.min(100, Math.max(0, effectiveScore));
        this.scoreChange = effectiveScore - this.vinterScore;
      }
    });
  }
  goToPreviousQuestion(){
    this.getPreviousOrNextQuestion.emit(this.selectedQuestion.order - 1)
  }
  goToNextQuestion(){
    this.getPreviousOrNextQuestion.emit(this.selectedQuestion.order + 1)
  }
  
  onHideSidebar(){
    if(!this.sidebarVisible)
      {
        this.onHideAnswerSidebar.emit(this.isScoreChanged)
      }
  }
  openChangeVinterScoreSidebar() {
    if((this.vinterScore !== null && this.vinterScore !== undefined) && this.answerType != AnswerType.MultipleChoice && (this.selectedQuestion.answerId !== null && this.selectedQuestion.answerId !== undefined)){
      this.changeScoreSidebarVisible = true;
    }
  }

  onSidebarClosed() {
    this.changeScoreSidebarVisible = false;
  }


  getAnswerData(){
    forkJoin({
      contentId: this.answerService.getAnswerContentIdByFilter({id: this.selectedQuestion?.answerId}),
      answer: this.answerService.getAnswerByFilter({id: this.selectedQuestion?.answerId})
    }).subscribe(({ contentId, answer }) => {
      this.answerContentID = contentId?.answerContentID;
      this.applicantID = contentId?.userId;

      if(answer.answerType == AnswerType.Coding){
        this.codingAnswer = answer;
      }
      else if(answer?.answerType == AnswerType.MultipleChoice){
        this.multipleChoiceAnswer = answer;
        if(this.multipleChoiceAnswer?.choiceAnswer?.isCorrect){
          this.vinterScore = 100;
        }
        else{
          this.vinterScore = 0;
        }
      }
      else if(answer.answerType == AnswerType.OpenEnded && answer.questionCollectionCategory != QuestionCollectionCategoryEnum.ForeignLanguage){
        this.openEndedAnswer = answer;
      }
      else if(answer.answerType == AnswerType.OpenEnded && answer.questionCollectionCategory == QuestionCollectionCategoryEnum.ForeignLanguage){
        this.writingAnswer = answer;
      }
      else if(answer.answerType == AnswerType.Video && answer.questionCollectionCategory != QuestionCollectionCategoryEnum.ForeignLanguage && answer.questionCollectionCategory != QuestionCollectionCategoryEnum.Pronunciation){
        this.videoAnswer = answer;
      }
      else if(answer.answerType == AnswerType.Video && answer.questionCollectionCategory == QuestionCollectionCategoryEnum.ForeignLanguage){
        this.speakingAnswer = answer;
      }
      else if(answer.answerType == AnswerType.Video && answer.questionCollectionCategory == QuestionCollectionCategoryEnum.Pronunciation){
        this.pronunciationVideoAnswer = answer;
      }

      if(answer.answerType !== AnswerType.MultipleChoice){
        this.vinterScore = answer?.answerContent?.gptEvalScore;
      }
      this.answerType = answer?.answerType;
      this.isResponse = true;
      if(answer?.answerContent?.gptEvalStatus == GPTEvalStatus.Waiting){
        this.isWaitingForAI = true;
      }

      this.getChangedScoreData(this.answerContentID, this.applicantID);
    });
  }

  updateSuspicionOfCheating(event:any)
  {
    this.updateSuspicionOfCheatingData.emit(event);
  }
}
